import { useDisclosure, useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import WorkshopDataService from "../../services/Workshop";
import { SingleWorkshopRow } from "../../components/List/SingleWorkshopRow";

export const WorkshopList = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("logged_in_user_token");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [list, setList] = useState<any>();
  const [modal, setModal] = useState<any>("");
  const toast = useToast();

  const [drawer, setDrawer] = useState("");

  const isNgodelete = (isdelete: true) => {
    fetchData();
  };

  const fetchData = async () => {
    WorkshopDataService.getAllWorkshops(token)
      .then((res: any) => {
        setList(res.data.data);
      })
      .catch((error: any) => {
        if (error.response.status === 401) {
          toast({
            position: "top",
            title: "Authentication Failed.",
            description: "Your session is expired.",
            status: "error",
            duration: 500,
            isClosable: true,
          });
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        }
        console.log(error);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <>
      <div className="main-wrapper">
        <div className="page_title py-2">Workshops - B2C Workshop</div>
        <div className="p-4">
          {/* Main secttion */}
          <div className="main-section">
            <table className="table">
              <thead>
                <tr>
                  {/* <th>Edit</th> */}
                  <th>Id</th>
                  <th>Title</th>
                  <th>Date</th>
                  <th>Start Time</th>
                  <th>End Time</th>
                  <th>Expert Name</th>
                  <th>Description</th>
                  <th>Price</th>
                  <th>Particiapnts</th>
                </tr>
              </thead>
              <tbody>
                {list && list.length > 0 ? (
                  list.map((el: any) => (
                    <SingleWorkshopRow key={el.id} props={el} />
                  ))
                ) : (
                  <h1 className="no-data">No Data Found</h1>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};
